const NUMBERTOSHOW = 2
const SEQUENCE = ['DIR', 'ACT', 'MES', 'AUT', 'PRE', 'PRO', 'CHO']

export {
  NUMBERTOSHOW,
  SEQUENCE
}
